/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import { useContext, useEffect, useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { NavLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AuthContext } from '~/contexts/authentication';
import { startAuditVisit } from '~/utils/auditCorrelation';

interface SidebarIconInterface {
  isActiveMenu: boolean;
}
const SidebarLink = styled(NavLink).attrs({ activeClassName: 'active' })`
  display: flex;
  font-size: 0.875rem;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 0.1rem;
  list-style: none;
  height: 60px;
  text-decoration: none;

  svg {
    font-size: 12px;
    margin-right: 10px;
    fill: #fff;
    width: 24px;
    height: 24px;

    path {
      transform: scale(1.2);
      transform-origin: center;
    }
  }

  &.active {
    color: #c80033;

    svg {
      fill: #c80033;
      width: 24px;
      height: 24px;
    }
  }
  div {
    display: flex;
    align-items: center;

    svg {
      font-size: 24px;
      margin-right: 10px;
      width: 24px;
      height: 24px;
    }
  }

  &:hover {
    background: #c80033;
    color: #fff;
    cursor: pointer;
  }
`;
interface IsActiveSidebarLabel {
  isActive?: boolean;
  depth?: number;
}
const SidebarLabel = styled.div<
  IsActiveSidebarLabel & { hasSubmenu?: boolean }
>`
  display: flex;
  flex: 1;
  font-size: 0.875rem;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem;
  padding-left: ${({ depth }) => depth * 1.5}rem;
  height: 60px;
  cursor: pointer;
  padding: 1rem;

  /* Filho final (sem filhos) → cor B */
  ${({ depth, hasSubmenu }) =>
    depth > 0 &&
    !hasSubmenu &&
    `
    background: #c800329b; 
    color: #fff;
  `}
  ${({ depth, hasSubmenu }) =>
    hasSubmenu &&
    `
    background: #e4003a; 
    color: #fff;
  `}

  ${({ isActive }) =>
    isActive &&
    `
      background: #fff;
      color: #e4003a;

      svg {
        fill: #e4003a !important;
      }
  `}

  svg {
    width: 24px;
    height: 24px;
    margin-right: 10px;
    fill: currentColor;
  }

  &:hover {
    background: #c80033;
    color: #fff;
  }
`;

const SidebarIcon = styled.div<SidebarIconInterface>`
  display: flex;
  font-size: 1rem;
  color: ${({ isActiveMenu }) => (isActiveMenu ? '#e4003a' : '#fff')};
  justify-content: flex-end;
  align-items: center;
  padding: 1.2rem;
  list-style: none;
  height: 60px;
  text-decoration: none;
  background: ${({ isActiveMenu }) => isActiveMenu && '#fff'};

  div {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 24px;
      margin-right: 7px;
      width: 24px;
      height: 24px;
      fill: ${({ isActiveMenu }) => (isActiveMenu ? '#e4003a' : '#fff')};
    }
  }

  &.active {
    color: #c80033;

    svg {
      fill: #c80033;
      width: 24px;
      height: 24px;
    }
  }

  &:hover {
    background: #c80033;
    color: #fff;
    cursor: pointer;
  }
`;

const Label = styled.span``;

const MenuItemWrapper = styled.div<{
  depth: number;
  showLine?: boolean;
  isTerminal?: boolean;
}>`
  position: relative;
  font-weight: ${(props) => (props.depth > 1 ? 700 : 500)};
`;
const hasActiveChild = (menuItem, currentPath) => {
  if (!menuItem.subMenu) return false;
  return menuItem.subMenu.some((child) => {
    if (child.route === currentPath) return true;
    return hasActiveChild(child, currentPath);
  });
};
const NestedSubMenu = ({ item, depth = 1 }) => {
  const location = useLocation();
  const { hasAnyRole } = useContext(AuthContext);
  const detailParentRoute = {
    '/negociacao-dividas/cliente': '/negociacao-dividas/buscar-cliente',
  };
  const isActiveRoute =
    item.route === location.pathname ||
    (!!item.route && location.pathname.startsWith(`${item.route}/`)) ||
    detailParentRoute[location.pathname] === item.route;

  const userHasAccess = hasAnyRole(item.roles);
  const [userOpened, setUserOpened] = useState(false);

  if (!userHasAccess) return null;
  const hasSubmenu = !!item?.subMenu;
  const isChildActive = hasActiveChild(item, location.pathname);

  const subnav = userOpened || isChildActive || isActiveRoute;
  const toggleSubnav = () => setUserOpened((prev) => !prev);

  return (
    <MenuItemWrapper
      isTerminal={false}
      depth={depth}
      showLine={subnav && hasSubmenu}
      style={{
        ...(hasSubmenu && {
          fontWeight: '700',
          backgroundColor: '#c800329b',
        }),
        ...(isActiveRoute && {
          backgroundColor: '#c800329b',
        }),
      }}
    >
      {hasSubmenu ? (
        <SidebarLabel
          depth={depth}
          hasSubmenu={hasSubmenu}
          onClick={toggleSubnav}
          isActive={isActiveRoute}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              alignItems: 'center',
            }}
          >
            {item.icon}
            <span>{item.label}</span>
          </div>
          <div>{subnav ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}</div>
        </SidebarLabel>
      ) : (
        <SidebarLink
          exact
          to={item.route}
          onClick={() => startAuditVisit(item.route)}
        >
          {item.icon}
          <SidebarLabel
            depth={depth}
            hasSubmenu={false}
            isActive={isActiveRoute}
          >
            <div>{item.label}</div>
          </SidebarLabel>
        </SidebarLink>
      )}
      {subnav &&
        hasSubmenu &&
        item.subMenu?.map((subItem) => (
          <NestedSubMenu key={subItem.route} item={subItem} depth={depth + 1} />
        ))}
    </MenuItemWrapper>
  );
};

const MenuItem = ({ fullWidth, item }) => {
  const [subnav, setSubnav] = useState(false);
  const { handleSideBar, hasAnyRole } = useContext(AuthContext);
  const showSubnav = () => setSubnav(!subnav);

  const location = useLocation();
  const itemLocation = location.pathname;

  const allLocations =
    item.subMenu &&
    item.subMenu.find((e) => {
      if (e.route === itemLocation) return true;
    });
  const isActiveRoute =
    (item.subMenu && allLocations) || item.route === itemLocation;
  const isChildActive = hasActiveChild(item, location.pathname);

  const userHasAccess = hasAnyRole(item.roles);

  const handleUserPermissions = () => {
    item.subMenu && showSubnav();
  };

  const handleOpenScreen = () => {
    startAuditVisit(item.route);
    handleUserPermissions();
  };

  useEffect(() => {
    if (isActiveRoute || isChildActive) {
      showSubnav();
    }
  }, [isActiveRoute, isChildActive]);

  if (!userHasAccess) {
    return null;
  }
  if (fullWidth) {
    return (
      <SidebarIcon isActiveMenu={isActiveRoute} onClick={handleSideBar}>
        <div>{item.icon}</div>
      </SidebarIcon>
    );
  }

  return (
    <MenuItemWrapper depth={0} showLine={subnav} isTerminal>
      {item.subMenu ? (
        <SidebarLabel
          depth={0}
          hasSubmenu={!!item.subMenu}
          onClick={handleUserPermissions}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              alignItems: 'center',
            }}
          >
            {item.icon}
            <Label>{item.label}</Label>
          </div>
          <div>
            {item.subMenu && subnav ? (
              <MdKeyboardArrowUp />
            ) : item.subMenu ? (
              <MdKeyboardArrowDown />
            ) : null}
          </div>
        </SidebarLabel>
      ) : (
        <SidebarLink exact to={item.route} onClick={handleOpenScreen}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              alignItems: 'center',
            }}
          >
            {item.icon}
            <Label>{item.label}</Label>
          </div>
          <div>
            {item.subMenu && subnav ? (
              <MdKeyboardArrowUp />
            ) : item.subMenu ? (
              <MdKeyboardArrowDown />
            ) : null}
          </div>
        </SidebarLink>
      )}
      <div style={{ background: '#c800329b' }}>
        {subnav &&
          item.subMenu &&
          item.subMenu.map((subItem) => (
            <NestedSubMenu key={subItem.route} item={subItem} depth={1} />
          ))}
      </div>
    </MenuItemWrapper>
  );
};

export default MenuItem;
